var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path14, _path15, _path16, _path17, _g, _g2, _g3, _path18, _path19, _path20, _line9, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImproveHydration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.872,
    height: 85.021,
    viewBox: "0 0 77.872 85.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.674,
    height: 15.76,
    transform: "translate(635.682 176.698)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.142,
    height: 11.069,
    transform: "translate(631.428 175.032)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.571,
    height: 13.983,
    transform: "translate(647.518 170.49)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19245.844 19119.699)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19845 -19288.324)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M638.539,219.239c-.1.446-.439.544-1.743,1.45a4.776,4.776,0,0,1-4.9,0c-1.3-.906-1.639-1-1.743-1.45",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M612.116,205.583a3.322,3.322,0,0,1,4.089.022,7.966,7.966,0,0,0,3.406,1.742,8.338,8.338,0,0,0,2.682.141,19.678,19.678,0,0,0,3.528-.847c.833-.234,1.532-.434,2.041-.58",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M616.4,208.84a3.19,3.19,0,0,1,2.507-1.694",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M656.4,205.583a3.322,3.322,0,0,0-4.089.022,7.966,7.966,0,0,1-3.406,1.742,8.333,8.333,0,0,1-2.681.141,19.657,19.657,0,0,1-3.529-.847c-.833-.234-1.532-.434-2.041-.58",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M649.6,207.146a3.19,3.19,0,0,1,2.507,1.694",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M611.821,231.627c4.589,6.314,11.7,11.957,16.71,15.491a9.986,9.986,0,0,0,11.673,0c2.173-1.53,4.738-3.458,7.32-5.663",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M607.1,187.47c.2,6.293-.736,30.857.679,36.191",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M661.366,201.871c-.2,6.293.736,16.457-.679,21.791-2.482,9.324-13.7,18.48-20.754,23.456a9.984,9.984,0,0,1-11.674,0c-2.172-1.53-4.737-3.458-7.319-5.663",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M627.769,197.928a8.669,8.669,0,0,0-5.187-2.767,28.444,28.444,0,0,0-8.127,0",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M638.835,197.889a8.669,8.669,0,0,1,5.187-2.767,10.16,10.16,0,0,1,2-.249",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M654.8,192.283c7.371,9.133,12.4,20.076,17.293,34.03",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M645.493,182.43c1.128,1.04,4.88,4.8,5.942,5.948",
    fill: "none",
    stroke: "#a64daa",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M634.216,173.8c1.4,1.048,2.53,1.88,3.932,2.939",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 12.251,
    x2: 23.059,
    transform: "translate(607.098 175.219)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 3.228,
    x2: 8.049,
    transform: "translate(634.217 170.576)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 3.073,
    x2: 7.662,
    transform: "translate(646.875 180.73)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 1.283,
    x2: 3.201,
    transform: "translate(661.635 200.742)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: 1.812,
    x2: 4.518,
    transform: "translate(657.688 193.947)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: 0.718,
    x2: 1.792,
    transform: "translate(665.453 207.275)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: 0.877,
    x2: 2.188,
    transform: "translate(667.48 213.777)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: 0.505,
    x2: 1.26,
    transform: "translate(670.191 220.049)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M640.53,233.484a1.374,1.374,0,0,1-.331-.064c.029-.04.043-.062.043-.062l-.2,0c-1.614-.708-2.965-4.189-3.942-4.565a7.889,7.889,0,0,0-2.32.392c-.392.114-1.8-.621-2.14-.441-.663.347-1.144,1.487-1.618,2.565a5.858,5.858,0,0,1-1.824,2.217h-.016l.006.007c-.1.071.15.174.15.174.827,1.014,2.182,3.284,6,3.166,3.239-.1,5.35-2.754,5.806-3.384Z",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M606.978,193.313c-1.136,3.689-6.322,7.343-6.322,14.176s1.547,8.7,5.074,8.7",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M666.223,211.622c-.572,3.063-1.9,3.065-3.278,3.065a1.5,1.5,0,0,0,0,3c2.414,0,3.976-.8,4.97-2.221q-.829-1.958-1.692-3.844",
    fill: "#a64daa"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M602.9,199.171v-15.42l1.657-1.078,20.817-11.06",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.95,181.67c-6.523,4.173-6.073,7.428-5.408,8.925s2.7,2.02,4.269.23c1.943-2.209,1.885-7.375,6.3-10.142a22.141,22.141,0,0,1,8.747-3.485A29.578,29.578,0,0,0,641.95,181.67Z",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.776,175.8c.363-.178.592-.279.592-.279-4.987,1.1-11.467,4.48-12.367,8.194-.488,2.013,1.589,2.752,3.278.522,1.841-2.43,2.228-3.992,4.265-5.766a18.129,18.129,0,0,1,3.008-2.032C643.032,176.172,643.457,175.955,643.776,175.8Z",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.629,172.759c-7-2.635-11.214-1.8-12.732-.836s-1.294,3.526,2.442,3.361,8.252-1.318,13,.638a24.407,24.407,0,0,1,7.672,5.5A19.851,19.851,0,0,0,661.629,172.759Z",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M635.627,195.333c0-.019,0-.038,0-.059s0-.034,0-.051l0-.027c0-.039,0-.079-.008-.118l0-.039-.006-.064,0-.026c-.005-.047-.009-.094-.015-.14,0-.025-.006-.05-.01-.074l0-.023c-.006-.043-.012-.086-.019-.128s-.01-.061-.016-.091-.015-.086-.024-.129l-.018-.088c-.009-.042-.019-.084-.029-.126s-.013-.056-.02-.084-.021-.079-.032-.118l-.007-.026c-.005-.02-.011-.04-.017-.06-.013-.044-.026-.086-.039-.128l-.007-.022-.015-.047c0-.011-.007-.021-.011-.032-.012-.036-.024-.073-.037-.108l-.017-.05c-.023-.064-.047-.127-.073-.189s-.048-.12-.074-.179l-.011-.026-.066-.146-.021-.043-.031-.062c-.009-.02-.018-.04-.028-.059l-.026-.05c-.018-.036-.037-.072-.056-.108l-.027-.05-.013-.022-.044-.079-.028-.049-.056-.1-.005-.007-.022-.038-.059-.094-.025-.039-.062-.1-.021-.031-.045-.066-.023-.033-.013-.02c-.04-.056-.08-.111-.12-.164s-.077-.1-.115-.15l-.014-.017-.056-.069-.087-.1c-.013-.016-.027-.031-.041-.047l-.181-.195a.221.221,0,0,0-.026-.027l-.034-.033a.173.173,0,0,0-.248,0,5.837,5.837,0,0,0-.548.656c-.051.069-.1.144-.157.223a6.562,6.562,0,0,0-1.14,3.1q-.01.126-.015.255c0,.061,0,.121,0,.183a2.784,2.784,0,0,0,.268,1.2,2.466,2.466,0,0,0,.216.365l.008.011c.015.021.029.04.044.059l.009.011a2.153,2.153,0,0,0,.146.168l.016.017.044.043.026.025.041.037.025.021c.025.022.051.042.076.061l.009.008.021.016.03.022.009.006.037.025.038.025.042.026.035.021.049.026.015.009.016.008.08.038.029.012.053.022.028.01.007,0,.055.018.032.011.063.017.024.007.09.019.026,0,.065.01.031,0,.062.006.031,0c.031,0,.063,0,.094,0a2.223,2.223,0,0,0,1.99-2.395c0-.058,0-.118,0-.181m-1.986,2.325-.085,0-.025,0-.058-.005-.028,0-.057-.009-.025,0-.078-.017-.014,0-.064-.018-.03-.01-.049-.017-.006,0-.024-.009-.049-.02-.027-.011-.071-.034-.026-.014-.044-.024-.033-.019-.037-.023-.033-.022a.4.4,0,0,1-.034-.023l-.011-.008a.169.169,0,0,1-.023-.017l-.02-.014-.008-.007c-.023-.017-.046-.036-.068-.055l-.024-.02c-.012-.01-.023-.021-.037-.034l-.021-.02-.038-.038-.016-.016a1.816,1.816,0,0,1-.13-.149l-.009-.011-.039-.053-.008-.011a2.206,2.206,0,0,1-.193-.326,2.5,2.5,0,0,1-.239-1.073c0-.078,0-.154.005-.23s.011-.179.02-.267a6.248,6.248,0,0,1,.995-2.75q.082-.127.162-.24a6.035,6.035,0,0,1,.6-.734l.027.026.195.209.037.044.084.1.054.066.014.018c.063.079.125.163.187.248.013.018.026.035.038.053l.013.019.066.1.02.031.024.036.036.055.024.038c.019.03.038.06.057.092l.021.035.005.008.054.092.027.047.054.1.027.049.054.1.01.019.015.03c.019.037.037.076.056.115l.021.043c.021.046.042.092.063.14l.011.024h0c.05.113.1.232.14.35l.014.041,0,.006.047.135.013.043.007.022.014.045c.008.026.016.052.023.078s.011.038.016.057l.007.024c.01.038.021.075.03.113s.013.053.02.08.018.079.027.12l.018.084c.008.04.015.081.022.122s.011.058.015.087.013.081.019.124l0,.02c0,.023.007.046.01.069.005.044.01.089.014.134l0,.027v.016c0,.014,0,.028,0,.042,0,.049.007.1.01.149l0,.029c0,.014,0,.029,0,.044v0c0,.081.005.155.005.226a1.99,1.99,0,0,1-1.781,2.144",
    fill: "#a64daa"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M635.627,195.333c0-.019,0-.038,0-.059s0-.034,0-.051l0-.027c0-.039,0-.079-.008-.118l0-.039-.006-.064,0-.026c-.005-.047-.009-.094-.015-.14,0-.025-.006-.05-.01-.074l0-.023c-.006-.043-.012-.086-.019-.128s-.01-.061-.016-.091-.015-.086-.024-.129l-.018-.088c-.009-.042-.019-.084-.029-.126s-.013-.056-.02-.084-.021-.079-.032-.118l-.007-.026c-.005-.02-.011-.04-.017-.06-.013-.044-.026-.086-.039-.128l-.007-.022-.015-.047c0-.011-.007-.021-.011-.032-.012-.036-.024-.073-.037-.108l-.017-.05c-.023-.064-.047-.127-.073-.189s-.048-.12-.074-.179l-.011-.026-.066-.146-.021-.043-.031-.062c-.009-.02-.018-.04-.028-.059l-.026-.05c-.018-.036-.037-.072-.056-.108l-.027-.05-.013-.022-.044-.079-.028-.049-.056-.1-.005-.007-.022-.038-.059-.094-.025-.039-.062-.1-.021-.031-.045-.066-.023-.033-.013-.02c-.04-.056-.08-.111-.12-.164s-.077-.1-.115-.15l-.014-.017-.056-.069-.087-.1c-.013-.016-.027-.031-.041-.047l-.181-.195a.221.221,0,0,0-.026-.027l-.034-.033a.173.173,0,0,0-.248,0,5.837,5.837,0,0,0-.548.656c-.051.069-.1.144-.157.223a6.562,6.562,0,0,0-1.14,3.1q-.01.126-.015.255c0,.061,0,.121,0,.183a2.784,2.784,0,0,0,.268,1.2,2.466,2.466,0,0,0,.216.365l.008.011c.015.021.029.04.044.059l.009.011a2.153,2.153,0,0,0,.146.168l.016.017.044.043.026.025.041.037.025.021c.025.022.051.042.076.061l.009.008.021.016.03.022.009.006.037.025.038.025.042.026.035.021.049.026.015.009.016.008.08.038.029.012.053.022.028.01.007,0,.055.018.032.011.063.017.024.007.09.019.026,0,.065.01.031,0,.062.006.031,0c.031,0,.063,0,.094,0a2.223,2.223,0,0,0,1.99-2.395C635.631,195.456,635.629,195.4,635.627,195.333Zm-1.986,2.325-.085,0-.025,0-.058-.005-.028,0-.057-.009-.025,0-.078-.017-.014,0-.064-.018-.03-.01-.049-.017-.006,0-.024-.009-.049-.02-.027-.011-.071-.034-.026-.014-.044-.024-.033-.019-.037-.023-.033-.022a.4.4,0,0,1-.034-.023l-.011-.008a.169.169,0,0,1-.023-.017l-.02-.014-.008-.007c-.023-.017-.046-.036-.068-.055l-.024-.02c-.012-.01-.023-.021-.037-.034l-.021-.02-.038-.038-.016-.016a1.816,1.816,0,0,1-.13-.149l-.009-.011-.039-.053-.008-.011a2.206,2.206,0,0,1-.193-.326,2.5,2.5,0,0,1-.239-1.073c0-.078,0-.154.005-.23s.011-.179.02-.267a6.248,6.248,0,0,1,.995-2.75q.082-.127.162-.24a6.035,6.035,0,0,1,.6-.734l.027.026.195.209.037.044.084.1.054.066.014.018c.063.079.125.163.187.248.013.018.026.035.038.053l.013.019.066.1.02.031.024.036.036.055.024.038c.019.03.038.06.057.092l.021.035.005.008.054.092.027.047.054.1.027.049.054.1.01.019.015.03c.019.037.037.076.056.115l.021.043c.021.046.042.092.063.14l.011.024h0c.05.113.1.232.14.35l.014.041,0,.006.047.135.013.043.007.022.014.045c.008.026.016.052.023.078s.011.038.016.057l.007.024c.01.038.021.075.03.113s.013.053.02.08.018.079.027.12l.018.084c.008.04.015.081.022.122s.011.058.015.087.013.081.019.124l0,.02c0,.023.007.046.01.069.005.044.01.089.014.134l0,.027v.016c0,.014,0,.028,0,.042,0,.049.007.1.01.149l0,.029c0,.014,0,.029,0,.044v0c0,.081.005.155.005.226A1.99,1.99,0,0,1,633.641,197.658Z",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M676.091,194.858a16.681,16.681,0,0,0-8.462-11.123,23.634,23.634,0,0,0-10.015-2.648s6.7.963,9.81,4.069a8.684,8.684,0,0,1,1.982,2.715c.422,1.062.113,1.71-.732,1.71-1.1,0-5.725-3.811-11.325-3.811-5.778,0-8.934,2.809-10.008,6.48-1.03,3.519-.193,7.5,2.456,9.259,2.827,1.875,5.313-.951,4.735-2.733s-2.824-3.828-2.45-6.538c.428-3.1,3.5-5.126,7.1-4.946,4.846.243,9.257,3.311,10.75,9.329,1.738,7.008-4.931,12.512-6.206,8.3C661.529,208.692,679.258,206.917,676.091,194.858Z",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x2: 1.755,
    y2: 1.329,
    transform: "translate(640.65 178.852)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M630.325,249.669a19.792,19.792,0,0,1-13.521,3.337,25.145,25.145,0,0,1-11.146-4.278s6.849,3.673,12.034,2.716a10.94,10.94,0,0,0,3.865-1.342c1.19-.771,1.4-1.632.626-2.216-1-.757-8.11-.149-13.222-4.021-5.273-4-6.027-8.984-4.228-13.4,1.725-4.228,5.5-7.63,9.253-7.555,4,.08,4.128,4.624,2.251,6.005s-5.475,1.874-7.185,4.841c-1.953,3.388-.69,7.54,2.738,9.853a12.737,12.737,0,0,0,13.288.517C626.279,243.515,631.217,249.089,630.325,249.669Z",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImproveHydration);
export default __webpack_public_path__ + "static/media/improve-hydration.bc173f96.svg";
export { ForwardRef as ReactComponent };